import { Component, Input, OnInit } from '@angular/core';
import { PolicyService } from 'app/services/policy-service';

@Component({
    selector: 'app-promo',
    templateUrl: './promo.component.html',
    styleUrls: ['./promo.component.scss']
})
export class PromoComponent implements OnInit {

    @Input() features: string[] = [
        'Accede rápidamente al chat con abogados.',
        'Entra fácilmente en tu Área Cliente.',
        'Consulta todos nuestros canales de atención.',
        'Ten siempre a mano tu número de póliza.'
    ];
    @Input() title: string = 'Tu equipo de abogados, siempre en tu móvil';
    @Input() subtitle: string = 'Añade tu tarjeta digital y accede de forma más ágil a todas las ventajas de tu seguro onLygal:';

    // URL de la tarjeta digital: wallet de la primera póliza (/policies/me) que lo tenga informado.
    walletUrl: string = null;

    constructor(private policyService: PolicyService) { }

    ngOnInit(): void {
        this.policyService.getMyPolicies()
            .then(success => {
                const list = (success && success.response) ? success.response : [];
                const withWallet = list.find(policy => policy && policy.wallet);
                this.walletUrl = withWallet ? withWallet.wallet : null;
            })
            .catch(() => {
                this.walletUrl = null;
            });
    }

    onDownloadCard(): void {
        if (this.walletUrl) {
            window.open(this.walletUrl, '_blank');
        }
    }
}
